//跳轉、錯誤處理、提示等方法放在這裡

import { CustomMessage } from "../components";

export const tip = (msg, code) => {
  CustomMessage({
    content: <>{msg}</>,
    type: "error",
  });
};

export const toLogin = (nuxt) => {
  // window.location.href = "/signin";
};

export const to403Page = (nuxt) => {
  // window.location.pathname = "/accessDenied";
};

export const toMaintenancePage = () => {
  window.location.pathname = "/in-maintenance";
};

export const toInternetErrorPage = () => {
  // window.location.pathname = "/connectionFailed";
};
